import { ChatStepId } from "../types/chat";
import { getChatStep, isChatStepId } from "./steps";

// Every scenario has to end on the application: it always applies, so the
// engine always has a step to show.
const LAST_STEP = ChatStepId.Application;

/** Returns the problems that make a scenario unsafe to ship; empty when valid. */
export const validateScenario = (scenario: {
  id: string;
  steps: readonly string[];
}): string[] => {
  const errors: string[] = [];
  const seen = new Set<string>();

  for (const id of scenario.steps) {
    if (!isChatStepId(id)) {
      errors.push(`unknown step "${id}"`);
      continue;
    }
    if (seen.has(id)) {
      errors.push(`step "${id}" is listed twice`);
    }
    for (const need of getChatStep(id).needs) {
      if (!seen.has(need)) {
        errors.push(`step "${id}" needs "${need}" earlier in the scenario`);
      }
    }
    seen.add(id);
  }

  if (scenario.steps.at(-1) !== LAST_STEP) {
    errors.push(`the last step must be "${LAST_STEP}"`);
  }

  return errors;
};
